import { DOMAIN_TYPE_USER } from '../../../consts';
/**
 * @param state
 */
export var getUser = function (state) {
    return function (userId) {
        return state.domain[DOMAIN_TYPE_USER] ? state.domain[DOMAIN_TYPE_USER][userId] : null;
    };
};
